import { useSelector } from "react-redux";
import { Route, Routes, Link, useRouteMatch, useLocation, useNavigate } from 'react-router-dom';
import DashBoardSidebar from "./DashboardSidebar";
import './index.css'
import Home from "./Home";
import Credentials from "./Credentials";
import IssueCredentials from "./IssueCredentials";
import Profile from "./Profile";
import BulkUpload from "./BulkUpload";
import BulkStatus from "./BulkStatus";
import VerificationData from "./Verifier/VerificationData";
import VerificationForms from "./Verifier/VerificationForms";
import FormDetails from "./Verifier/FormDetails";
import VerifiedData from "./Verifier/VerifiedData";
import { useEffect, useState } from "react";
import VerifyUsers from "./Verifier/VerifyUsers";
import VerifierRequests from "./Verifier/VerifierRequests";
import ChangeRequest from "./Issuer/ChangeRequest";
import VerifierForms from "../VerifierInternalDashboard/VerifierForms";
import VerifierFields from "../VerifierInternalDashboard/VerifierFields";
import SelectForm from "./Verifier/RequestVerifications/SelectForm";
import RecipientsDetails from "./Verifier/RequestVerifications/recipientsDetails";
import MyRequests from "./Verifier/RequestVerifications/MyRequests";
import RequestDetails from "./Verifier/RequestVerifications/RequestDetails";
import CreateForm from "./Verifier/RequestVerifications/CreateVeriferForm";
import FormType from "./Verifier/RequestVerifications/FormType";
import BulkRecipients from "./Verifier/RequestVerifications/BulkRecipients";

import Documents from "../../DashBoard/Document";
import { DocumentDetails } from "./Issuer/DocumentDetails";
import DocumentType from "../DocumentType";
import SelectForms from "./Verifier/RequestVerifications/SelectForms";
import HelpandSupport from "../../Contact Us";
import QrReader from "./Verifier/QrReader";
import FaceMatch from "./Verifier/FaceMatch";
import EmpSearch from "./Employment/employmentDetails";
import Packages from "./Employment/Packages";
import VerifierDocRequest from "./Issuer/VerifierDocRequest";
import EmpRequest from "./Employment/MyRequests";
import EMPRequestDetails from "./Verifier/RequestVerifications/EmpRequestDetails";
import { IssuerRoutes } from "../../../Routes/IssuerRoutes";
import { EmpRoutes } from "../../../Routes/EmploymentRoute";
import { VerifierRoutes, VisitorRoutes } from "../../../Routes/VerifierRoutes";
import usePageTitle from "../../../Hooks/useDocTitle";
import CartDetail from "../../Cart/CartDetails";
import CartCheckOut from "../../Cart/Checkout";
import WalletDetails from "../../Cart/Wallet";
import CreateAppeal from "./Verifier/RequestVerifications/CreateAppeal";
import VerifierAppeal from "./Issuer/VerifierAppeal";
import DocumentDiscrepencyDetails from "./Issuer/DocumentDiscrepencyDetails";
import VerificationRequests from "./Issuer/VerificationRequests";
import RecordInsights from "./Issuer/RecordInsights";
import WACreateAppeal from "./Verifier/RequestVerifications/WACreateAppeal";
import CreditLedger from "../../Issuer Credit/CreditLedger";
import UserRoletypeSelection from "../../User Roletype Popup/UserRoletypeSelection";
import IssueDocumentDetails from "./IssueDocumentDetails";
import AuthNumberIssuers from "./Verifier/AuthNumberIssuers";
import IssueDocumentRequest from "./IssueDocumentRequest";
import QryptalData from "../../Qryptal QR/QryptalData";
import RecordsReports from "./Issuer/RecordsReports";
import CreditDetails from "../../Credit/CreditDetails";

const ExternalDash = () => {
  
  usePageTitle('DashBoard')
  const location = useLocation();
  const pathname = location.pathname;
  const User = useSelector(state => state.User)
  const ISSUER_ID = User.id
  const [height, setHeight] = useState(window.innerHeight - 240)
  const navigate=useNavigate()
  const [showSelectRole, setShowSelectRole]=useState(false)
  useEffect(() => {
    const handleResize = () => {
      setHeight(window.innerHeight - 240)
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  useEffect(() => {
    if (User?.user_role_name == null) {
      setShowSelectRole(true);
    } else {
      setShowSelectRole(false);
    }
  }, [User?.user_role_name])
  useEffect(()=>{

    const docToken = localStorage.getItem("doc_token");

    if (
      docToken &&
      !window.location.pathname.includes("/dashboard/verify-details")
    ) {
      window.location.replace(
        `/dashboard/verify-details${docToken}`
      );
    }
    }, [])
  return (
    <div className='dashboard' style={{ minHeight: height > 450 ? height : '' }}>
      <UserRoletypeSelection isOpen={showSelectRole}/>
      {pathname.includes('/Help') ? null : <DashBoardSidebar />}
      <div className={pathname.includes('/Help') ? "" : "dashboard-right"}>
        <div
          // className="w-100"
          style={{ width: 'inherit' }}
        >
          <Routes>
            <Route path="/" strict element={<Home />} />

            <Route element={<IssuerRoutes />}>
              <Route path='/credentials' element={<Credentials ISSUER_ID={ISSUER_ID} />} />
              <Route path='/mydocuments' element={<Documents id={ISSUER_ID} />} />
              <Route path='/details' element={<DocumentDetails id={ISSUER_ID} />} />
              <Route path='/credentials/indraft' element={<Credentials ISSUER_ID={ISSUER_ID} />} />
              <Route path='/credentials/issue-credentials' element={<IssueCredentials ISSUER_ID={ISSUER_ID} />} />
              {/* <Route path='/credentials/bulkupload' element={<BulkUpload ISSUER_ID={ISSUER_ID} />}/> */}
              <Route path='/credentials/bulkupload/bulkstatus' element={<BulkStatus ISSUER_ID={ISSUER_ID} />} />
              <Route path='/change-request/:docID' element={<ChangeRequest />} />
              <Route path="/verifierDocRequests" element={<VerifierDocRequest ISSUER_ID={ISSUER_ID} />} />
              <Route path="/TemplateType" element={<DocumentType id={User.id} />} />
              <Route path="/DocAppeals" element={<VerifierAppeal id={ISSUER_ID}/>}/>
              <Route path="/doc_descrepency_details/:appeal_id" element={<DocumentDiscrepencyDetails/>}/>
              <Route path="verification_requests" element ={<VerificationRequests/>}/>
              <Route path="/record_insights" element={<RecordInsights/>}/>
              <Route path="/creditLedger" element={<CreditLedger/>}/>
              <Route path="/documentDetails/:issued_uuid" element={<IssueDocumentDetails/>}/>
              <Route path="/issueDocumentRequest" element={<IssueDocumentRequest/>}/>
              <Route path="/record_reports" element ={<RecordsReports id={ISSUER_ID}/>}/>

            </Route>
            <Route element={<VerifierRoutes />}>
              <Route path='/verifier-data' element={<VerificationData />} />
              <Route path='/verify-users' element={<VerifyUsers />} />
              <Route path='/request-sent' element={<VerifierRequests />} />
              {/* <Route path='/forms' element={<VerificationForms />} /> */}
              <Route path="/verification-fields" element={<VerifierFields isEdit={false} id={User.id} />} />
              <Route path="/verifier-forms" element={<VerifierForms id={User.id} />} />
              <Route path="/verification-fields/:uuid" element={<VerifierFields isEdit={true} id={User.id} />} />
              <Route path='/forms/:form_id' element={<FormDetails />} />
              <Route path="/forms/selectType" element={<SelectForm id={User.id} />} />
              <Route path="/forms/RecipientsDetails" element={<RecipientsDetails id={User.id} />} />
              <Route path="/forms/BulkRecipients" element={<BulkRecipients />} />
              <Route path="/forms/myRequests/" element={<MyRequests id={User.id} />} />
              <Route path="/forms/requestDetails/:request_id" element={<RequestDetails />} />
              <Route path="/verification-fields/:uuid" element={<VerifierFields isEdit={true} id={User.id} />} />
              <Route path="/forms/createForm" element={<CreateForm />} />
              <Route path="/forms/formType" element={<FormType />} />
              <Route path="/forms/qrReader" element={<QrReader />} />
              <Route path="/forms/faceMatch" element={<FaceMatch />} />
              <Route path="/forms/selectForms" element={<SelectForms ISSUER_ID={User.id} />} />
              <Route path="/forms/qrReader" element={<QrReader />} />
              <Route path="/forms/faceMatch" element={<FaceMatch />} />
              <Route path='verifier-data/:holder_id' element={<VerifiedData />} />


              <Route path="/Issuers" element={<AuthNumberIssuers/>}/>
              <Route element={<EmpRoutes />}>
                <Route path="/emp/packages" element={<Packages id={User.id} />} />
                <Route path="/emp/requests" element={<EmpRequest id={User.id} />} />
                <Route path="/emp/requestDetails/:request_id/:issuer_id/:verification_request_id" element={<EMPRequestDetails />} />
                <Route path="/emp/search" element={<EmpSearch id={User.id} />} />
                <Route path="/emp/appeal/:issued_doc_id/:issuer_id/:verification_request_id" element={<CreateAppeal id={User.id} />}/>
                <Route path="/emp/WAAppeal/:verification_request_id" element={<WACreateAppeal/>}/>
              </Route>

            </Route>

            <Route path="/profile/:id" element={<Profile />} />
            <Route path="/Help/*" element={<HelpandSupport />} />
            <Route path="/cart" element={<CartDetail />} />
            <Route path="/success" element={<CartCheckOut />} />
            <Route path="/wallet" element={<WalletDetails />} />
            <Route path="/credit" element={<CreditDetails />} />
            <Route path="/verify-details/" element={<QryptalData/>}/>
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default ExternalDash;
